import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap-icons/font/bootstrap-icons.css";

import { createPinia } from "pinia";
import Vue3Toastify, { type ToastContainerOptions } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import FloatingVue from "floating-vue";
import "floating-vue/dist/style.css";
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";

import "./Styles/site.scss";

const app = createApp(App);
const pinia = createPinia();

app.use(router);
app.use(pinia);

app.use(Vue3Toastify, {
  autoClose: 3000,
} as ToastContainerOptions);

app.use(FloatingVue, {
  themes: {
    tooltip: {
      html: true,
    },
    popover: {
      html: true,
    },
    "info-tooltip": {
      $extend: "tooltip",
      $resetCss: true,
    },
  },
});

app.component("VueDatePicker", VueDatePicker);

app.mount("#app");
